import React, { FocusEvent } from 'react';

import { FormikErrors, FormikTouched } from 'formik';

import {
  EQuantityFieldControl,
  EQuantityFormatKey,
  IQuantityFieldDescriptor,
  IQuantityFormat
} from '../../../StoreSettings.types';

import { QuantityFormatBooleanField } from './QuantityFormatBooleanField';
import { QuantityFormatNumberField } from './QuantityFormatNumberField';
import { QuantityFormatSeparatorField } from './QuantityFormatSeparatorField';

interface IQuantityFormatFieldProps {
  descriptor: IQuantityFieldDescriptor;
  name: EQuantityFormatKey;
  quantityFormat: IQuantityFormat;
  isFetching: boolean;
  touched?: FormikTouched<IQuantityFormat>;
  errors?: FormikErrors<IQuantityFormat>;
  onFieldChange: (fieldPath: string, rawValue: string) => void;
  onBlur: (event: FocusEvent<HTMLElement>) => void;
}

export const QuantityFormatField = ({
  descriptor,
  name,
  quantityFormat,
  isFetching,
  touched,
  errors,
  onFieldChange,
  onBlur
}: IQuantityFormatFieldProps): React.ReactElement => {
  const fieldPath = `${name}.${descriptor.key}`;
  const value = String(quantityFormat[descriptor.key]);
  const error =
    Boolean(touched?.[descriptor.key]) && Boolean(errors?.[descriptor.key]);

  if (descriptor.control === EQuantityFieldControl.NUMBER) {
    const helperText = error ? String(errors?.[descriptor.key]) : '';
    return (
      <QuantityFormatNumberField
        header={descriptor.header}
        name={fieldPath}
        value={value}
        error={error}
        helperText={helperText}
        onFieldChange={onFieldChange}
        onBlur={onBlur}
      />
    );
  }

  if (descriptor.control === EQuantityFieldControl.SEPARATOR) {
    return (
      <QuantityFormatSeparatorField
        header={descriptor.header}
        name={fieldPath}
        value={value}
        isFetching={isFetching}
        error={error}
        onFieldChange={onFieldChange}
        onBlur={onBlur}
      />
    );
  }

  return (
    <QuantityFormatBooleanField
      header={descriptor.header}
      name={fieldPath}
      value={value}
      isFetching={isFetching}
      error={error}
      onFieldChange={onFieldChange}
      onBlur={onBlur}
    />
  );
};
